module.exports = __webpack_public_path__ + "static/media/KenyaVisitingVisa.97c0c0c3.mp4";